import { Form, Formik } from 'formik'

import UniversalAddress from '../../sharedcomponents/2compounds/UniversalAddress'

export default function Stuff () {
  // searchStatesCallback(['CA'])

  // searchCitiesCallback([{ countryCode: 'CA', isoCode: 'AB' }])

  return (
    <div className='App'>
      sdfffffffffffffffffffffffffffffffffffff
      <Formik
        initialValues={{ addresses: [{}] }}
        enableReinitialize
        validateOnChange={true}
        onSubmit={values => {
          console.log('values in detail wrapper', values)
        }}
      >
        {formikProps => {
          return (
            <div style={{ height: '100%', width: '100%' }}>
              <Form>
                <UniversalAddress
                  editMode={true}
                  setFieldValue={formikProps.setFieldValue}
                  values={formikProps.values}
                ></UniversalAddress>
              </Form>
            </div>
          )
        }}
      </Formik>
    </div>
  )
}
